import $ from 'jquery';
import _ from 'underscore';
import Handlebars from 'handlebars';
import Global from 'models/Global';
import BootstrapData from 'models/BootstrapData';
import SectionView from 'views/SectionView';
import RenderedView from 'views/RenderedView';
import RenderedCollectionView from 'views/RenderedCollectionView';
import template from 'hbars!templates/homePageView';
import FeatureToggleUtils from 'FeatureToggleUtils';
import website_style_view from 'hbars!web-common/scripts/templates/website_style_view';
import sectionsStyleTemplate from 'hbars!web-common/scripts/templates/sections_style_view';
import venue_location_map from 'hbars!web-common/editor-templates/templates/common/venueLocationMap';
import { getSectionsListStyles } from 'web-common/scripts/utils/sectionsCss';
import { parseSectionsListCustomization } from 'web-common/scripts/utils/sectionsCustomization/parsers';
import { getSectionsListCss } from 'web-common/scripts/utils/atomic/css';
import atomicStructure from 'web-common/scripts/utils/atomic/structure';
import { LocalStorageApi, LOCAL_STORAGE_KEYS } from 'utils/LocalStorageUtil';
import { addTransifexListeners } from 'utils/TransifexUtils';

Handlebars.registerPartial('website_style_view', website_style_view);
Handlebars.registerPartial('venueLocationMap', venue_location_map);

var HomePageView = RenderedView.extend({

    events: {
        'click .js-register-btn-holder': 'registerBtnClicked',
        'click .js-submission-btn-holder': 'formBtnClicked'
    },

    initialize: function(options) {
        options = options || {};
        this.isMobile = options.isMobile;
        this.sectionsView = new RenderedCollectionView({
            model: this.model,
            ItemView: SectionView
        });
        this.tabSection = options.tabSection;
        this.siteConf = options.siteConf;
        const event = Global.get('event');
        addTransifexListeners(event.attributes);
    },

    scrollToElement: function(selector) {
        var ticketsWidget = this.$(selector);
        if (ticketsWidget.length === 0) {
            return;
        }
        if (this.isMobile && ticketsWidget.get(0).scrollIntoViewIfNeeded) {
            ticketsWidget.get(0).scrollIntoViewIfNeeded();
        } else {
            var topBarHeight = 70;
            var posToScroll = (ticketsWidget.offset().top) - topBarHeight;
            $('html, body').animate({
                scrollTop: posToScroll
            }, 1000);
        }
    },

    registerBtnClicked: function() {
        this.scrollToElement('.tickets');
    },

    formBtnClicked: function() {
        this.scrollToElement('.js-submission-form');
    },

    remove: function() {
        this.skrollr && this.skrollr.destroy();
        this.sectionsView.remove();
        return RenderedView.prototype.remove.call(this);
    },

    render: function() {
        const event = Global.get('event');
        RenderedView.prototype.render.call(this, template, _.extend({
            event: event.toJSON(),
            tabSection: this.tabSection
        }, {
            joinRequired: event.isJoinRequired()
        }));

        return this;
    },

    postRender: function() {
        const sections = this.model.toJSON();
        const sectionsWithParsedCustomizations = parseSectionsListCustomization(sections);
        const customizationStyles = getSectionsListStyles(sectionsWithParsedCustomizations, false, {}, BootstrapData('bootstrap-data-usedFonts'));
        const customizationAtomicStyles = getSectionsListCss(atomicStructure, this.siteConf.toJSON(), sectionsWithParsedCustomizations);


        if (this.$('.sections-holder')[0]) {
            this.sectionsView.setElement(this.$('.sections-holder')).render();
        }
        const html = sectionsStyleTemplate(this.model.toJSON());
        $('.js-sections-style').html(customizationStyles + '\n' + customizationAtomicStyles + '\n' + html);

        let videos = document.querySelectorAll('.video-element');
        videos = [].slice.call(videos);
        videos && videos.forEach(video => {
            const playPromise = video.play();
            if (playPromise !== undefined){
                playPromise.then(() => {
                }).catch(e => {
                    video.load && video.load();
                });
            }
        });
    }
});

export default HomePageView;

